export default "__VITE_ASSET__CrbSNuAq__"